/**
 * The coming-soon feature's own routes.
 *
 * The page itself has no route here: it renders at `/` when the deployment
 * says so (see `features/merchant-intake/LandingRoute.tsx`). What this file
 * declares is the development-only review route — the reference's review
 * panel (states, framed viewports, reduced motion, simulated acceptance) as
 * a page. It exists in a development server only: the branch below is dead
 * code in a production build, so the review page and its simulated
 * submission are never bundled.
 */

import { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';

export const COMING_SOON_REVIEW_PATH = '/__review/coming-soon';

const ReviewPage = import.meta.env.DEV
  ? lazy(() => import('./review/PublicEarlyAccessReviewPage.js'))
  : null;

export function comingSoonReviewRoutes() {
  if (ReviewPage === null) return null;
  return (
    <Route
      path={COMING_SOON_REVIEW_PATH}
      element={
        <Suspense fallback={null}>
          <ReviewPage />
        </Suspense>
      }
    />
  );
}
